import React from 'react';
import * as Sentry from '@sentry/browser';
import { lsgetItem } from '../helpers/localStorageHelper';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { eventId: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        var user = lsgetItem('user');/*  JSON.parse(localStorage.getItem('user')); */
        Sentry.configureScope(function (scope) {
            scope.setExtras(errorInfo);
 
            scope.setLevel(Sentry.Severity.Info);
            scope.setUser({
                id: user ? user.userGuid : 'noUser',
                email: user ? user.userGuid : 'noUser'
            });
           
        });
        const eventId = Sentry.captureException(error);
        this.setState({ eventId });
    }

    render() {
        if (this.state.hasError) {
            //render fallback UI
            return (
                <button onClick={() => Sentry.showReportDialog({ eventId: this.state.eventId })}>Report feedback</button>
            );
        }

        //when there's not an error, render children untouched
        return this.props.children;
    }
}
